import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Center from "@/components/Center.vue";
import SaveFailed from "@/components/form/SaveFailed.vue";
/* import { useRouter } from "vue-router";

const router = useRouter();
const session = useSessionStore();
onMounted(() => {
	if (!session.$state.formSentSuccesfully) {
		session.$state.formSentSuccesfully = false;
		router.push({ name: "home" });
	}
}); */

export default /*#__PURE__*/_defineComponent({
  __name: 'SaveFailedView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Center, null, {
    default: _withCtx(() => [
      _createVNode(SaveFailed)
    ]),
    _: 1
  }))
}
}

})